import { Controller, useFormContext } from "react-hook-form";

import { FormInput } from "@/components/campos-formulario/novos/FormInput";
import { FormTextarea } from "@/components/campos-formulario/novos/FormTextarea";
import { FormMarkdownEditor } from "@/components/campos-formulario/novos/FormMarkdownEditor";
import { FormSubBlock } from "@/components/campos-formulario/form-shell/FormSubBlock";
import { ComunicadoSistemaFormData } from "@/validations/comunicado-sistema-validation-schema";
import { ComunicadoPreview } from "./ComunicadoPreview";

/** Passo "Conteúdo": título, resumo e corpo em markdown. */
export function ConteudoSection() {
  const { control } = useFormContext<ComunicadoSistemaFormData>();

  return (
    <div>
      <FormSubBlock title="Identificação">
        <div className="grid grid-cols-1 gap-5">
          <Controller
            name="titulo"
            control={control}
            render={({ field, fieldState }) => (
              <FormInput
                {...field}
                label="Título"
                placeholder="Ex.: Manutenção programada"
                required
                maxLength={200}
                error={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="resumo"
            control={control}
            render={({ field, fieldState }) => (
              <FormTextarea
                {...field}
                value={field.value || ""}
                label="Resumo"
                helperText="1–2 frases. É o que aparece na barra, no sino e nos cards."
                placeholder="Ex.: Sistema indisponível sábado das 14h às 16h."
                required
                rows={2}
                error={fieldState.error?.message}
              />
            )}
          />
        </div>
      </FormSubBlock>

      <FormSubBlock title="Conteúdo completo">
        <Controller
          name="conteudo"
          control={control}
          render={({ field }) => (
            <FormMarkdownEditor
              label="Conteúdo (markdown, opcional)"
              helperText="Abre num diálogo quando o usuário clica no comunicado."
              value={field.value || ""}
              onChange={field.onChange}
              onBlur={field.onBlur}
              height={220}
            />
          )}
        />
      </FormSubBlock>

      {/* Prévia enquanto digita: título e resumo são escritos para caber na
          barra, então mostrar a barra é mais útil que qualquer helperText. */}
      <FormSubBlock title="Como fica na barra">
        <ComunicadoPreview compacto />
      </FormSubBlock>
    </div>
  );
}
